import React from "react";
import { useDispatch } from "react-redux";
import modalStyles from "./styles.module.css";
import { updateSessionRefund } from "../../../../../store/actions/student";

const CancelModal = ({ setCancelModal, width, cancelSession, availDetails, cardInfo }) => {
  const [page, setPage] = React.useState("1");
  const dispatch = useDispatch();

  const platformFees = cardInfo.paymentId.platformFees;
  let refundPercent = 100;
  const refundAmount = (cardInfo.paymentId.itemPrice / Number(cardInfo.type)) * (refundPercent / 100) + platformFees / Number(cardInfo.type);
  const sessionObj = React.useMemo(() => ({ sessionId: cardInfo._id, amount: Number(refundAmount) }), [cardInfo._id, refundAmount]);

  React.useEffect(() => {
    dispatch(updateSessionRefund(sessionObj));
  }, [dispatch, sessionObj]);

  return (
    <div className={modalStyles.modalBackdrop}>
      <div className={modalStyles.modal}>
        <div
          className={modalStyles.closeBtn}
          onClick={() => { setCancelModal(false); setPage("1"); }}
        >
          <i className="fas fa-close"></i>
        </div>
        <h2 className={modalStyles.modalHeading}>Cancel Lesson</h2>

        <div className={modalStyles.modalBody}>
          {page === "1" ? (
            <Page1
              setPage={setPage}
              setCancelModal={setCancelModal}
              refundAmount={refundAmount}
              refundPercent={refundPercent}
            />
          ) : (
            <Page2
              setCancelModal={setCancelModal}
              cancelSession={cancelSession}
              refundAmount={refundAmount}
              refundPercent={refundPercent}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const Page1 = ({ setPage, setCancelModal, refundAmount, refundPercent }) => (
  <>
    <div className={modalStyles.summaryBox}>
      <p style={{ margin: 0 }}>
        Cancelling this lesson will result in a <strong>{refundPercent}% refund</strong> which is <strong>${refundAmount.toFixed(2)}</strong>.
      </p>
      <p style={{ marginTop: "1rem", color: "#ef4444", fontWeight: "600" }}>
        ⚠️ This action cannot be undone.
      </p>
    </div>

    <div className={modalStyles.actionArea}>
      <button
        className={modalStyles.secondaryBtn}
        onClick={() => setCancelModal(false)}
      >
        Keep Lesson
      </button>
      <button
        className={modalStyles.dangerBtn}
        onClick={() => setPage("2")}
      >
        Continue to Cancel
      </button>
    </div>
  </>
);

const Page2 = ({ setCancelModal, cancelSession, refundAmount, refundPercent }) => (
  <>
    <div className={modalStyles.summaryBox}>
      <ul style={{ paddingLeft: "1.2rem", margin: 0 }}>
        <li>This lesson will be removed from your schedule.</li>
        <li>The student will be automatically notified.</li>
        <li>Refund of <strong>${refundAmount.toFixed(2)}</strong> will be processed.</li>
      </ul>
    </div>

    <div className={modalStyles.reasonArea}>
      <label>Reason for Cancellation</label>
      <textarea rows="3" placeholder="Please provide a reason for the student..."></textarea>
    </div>

    <div className={modalStyles.actionArea}>
      <button
        className={modalStyles.secondaryBtn}
        onClick={() => setCancelModal(false)}
      >
        Go Back
      </button>
      <button
        className={modalStyles.dangerBtn}
        onClick={cancelSession}
      >
        Confirm Cancellation
      </button>
    </div>
  </>
);

export default CancelModal;
